// conversation.ts — §9 P6: pure routing decision for LISTENER-side audio.
//
// The listener app plays exactly two kinds of room audio:
//   1. the server-published `mix` track (the sacred path — meter, timecode,
//      lossless crossfade all hang off it), and
//   2. ADDITIVE "conversation" audio: the microphones of call participants
//      (`call-*`) and the host (`host-*`), so listeners hear Mix + Gespräch.
// Everything else (camera/screenshare video, unknown publishers) is ignored.
//
// Kept free of livekit-client imports so the decision is unit-testable in node.

/** Name of the server-published mix audio track (PROTOCOL §2). */
export const MIX_TRACK_NAME = "mix";

/**
 * True when a subscribed track is conversation audio for the listener page:
 * an AUDIO track that is NOT the mix and not from the server publisher.
 * Covers call-console participants (`call-*`), the host console (`host-*`)
 * AND §14 call-promoted listeners (`listener-*` identities that were granted
 * publish rights live) — the ingest publisher only ever publishes `mix`, so
 * every other audio in the room is by definition a human microphone.
 */
export function isConversationAudio(
  kind: string,
  trackName: string,
  publisherIdentity: string,
): boolean {
  if (kind !== "audio") return false;
  if (trackName === MIX_TRACK_NAME) return false;
  return !publisherIdentity.startsWith("ingest-");
}
